import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios';

import { loadProgressBar } from 'axios-progress-bar'

Vue.use(Vuex);

const URL = 'http://localhost:8085/api/';
const MAIL = 'http://codigo46.me:3000/mail/sekai'

var store = new Vuex.Store({
    state: {
        itemSelected: 'Index',
       servicio: "empresa",
       loading: false,
        template: 'black',
        data: [
            {
                title: 'PERSONAL',
                items: [
                    {
                        nombre: 'Domum',
                        codigo: 'P-001',
                        serie: 'A',
                        precio: '4000.00',
                        procesador: 'Intel i9 8400',
                        ram: '16GB DDR4',
                        grafica: 'RTX 2070 8 GB',
                        storage: '1 TB',
                        imagen: 'blue-marine-1.png',
                        categoria: 'Personal',
                        tipo: "INTEL"
                    },
                    {
                        nombre: 'Opus',
                        codigo: 'O-001',
                        serie: 'A',
                        precio: '4000.00',
                        procesador: 'Intel i9 8400',
                        ram: '16GB DDR4',
                        grafica: 'RTX 2070 8 GB',
                        storage: '1 TB',
                        imagen: 'pc-escritorio.png',
                        categoria: 'Oficina',
                        tipo: 'INTEL'
                    },
                    {
                        nombre: 'Progressio',
                        codigo: 'S-001',
                        serie: 'B',
                        precio: '4000.00',
                        procesador: 'Intel i9 8400',
                        ram: '16GB DDR4',
                        grafica: 'RTX 2070 8 GB',
                        storage: '1 TB',
                        imagen: 'thanos-pc.png',
                        categoria: 'Software y Diseño',
                        tipo: "AMD"
                    },
                    {
                        nombre: 'Deus',
                        codigo: 'D-001',
                        serie: 'Z',
                        precio: '4000.00',
                        procesador: 'Intel i9 8400',
                        ram: '16GB DDR4',
                        grafica: 'RTX 2070 8 GB',
                        storage: '1 TB',
                        imagen: 'dreammachine-pc.png',
                        categoria: 'PRO',
                        tipo: "AMD"
                    }
                ]
            }
        ]
    },
    mutations: {
        select_menu (state, menu) {
            state.itemSelected = menu
        },
       SET_LOADING: (state, loading) => {
          state.loading = loading;
       },
        SET_TEMPLATE: (state, template) => {
            state.template = template;
        },

    },
    actions: {
        login(context, data) {
            loadProgressBar();
            axios({
                method: 'post',
                url: URL + 'login',
                data: data
            }).then(data => {

            }).catch(error => {

            });
        },
       enviarCorreo: (context, data) => {
          context.commit('SET_LOADING', true);
          axios({
             method: 'post',
             url: MAIL,
             data: data
          }).then(r => {
             setTimeout(() => {
                context.commit('SET_LOADING', false);
             }, 1000)
          });
       },
    }
});

export default store
